<!-- Desktop -->
@if (!isMobile) {
  <div class="modal-body d-none d-md-inline-flex justify-content-center">
    <div class="content">
      @if (popupDispalyObj.type == 'actionDialog') {
        <div style="display: contents">
          @if (popupDispalyObj.imageSrc) {
            <img class="text-center" src="{{ popupDispalyObj.imageSrc }}"
              [ngStyle]="{ width: popupDispalyObj.confirm === 'Download' ? '120px' : '64px' }" alt="tick-img" />
          }
          <div class="psic-pt-1">
            <h5 [ngClass]="{ 'text-center': align == 'center' }" [innerHTML]="popupDispalyObj.message"></h5>
            <p class="psic-pt-1 caption" [ngClass]="{ 'text-center': align == 'center' }" [innerHTML]="popupDispalyObj.messageExt"></p>
          </div>
        </div>
      }
      @if (popupDispalyObj.type == 'actionDialog') {
        <form [formGroup]="desktopForm()">
          @if (popupDispalyObj.fields?.length > 0) {
            <div class="d-flex flex-column align-items-center psic-mt-6">
              @for (field of popupDispalyObj.fields; track field) {
                @if (field.type == 'text' || field.type == 'email') {
                  <div>
                    <lib-input-text [formControlName]="field.name" [field]="field"> </lib-input-text>
                  </div>
                }
              }
            </div>
          }
        </form>
      }
      @if (popupDispalyObj.type == 'paymentScehedule') {
        <div class="d-flex flex-row align-items-start">
          <div class="psic-ml-4 flex-column">
            <h5 class="intro-quote-text psic-mb-4" [innerHTML]="popupDispalyObj.message"></h5>
            <p [ngClass]="popupDispalyObj.helpText ? 'alt' : 'alt-bold'" [innerHTML]="popupDispalyObj.messageExt"></p>
          </div>
        </div>
      }
      <div class="psic-mt-6 d-flex flex-row align-items-center">
        @if (popupDispalyObj.cancel) {
          <div class="psic-mr-5">
            <div class="d-flex psic-pr-9">
              <lib-button (callback)="footerButtonAction(popupDispalyObj.cancel)" [disabled]="false"
                [buttonTheme]="'primary'" [buttonType]="'borderless'" [buttonSize]="'medium'"
                [buttonText]="popupDispalyObj.cancel" [libIcon]="'back'" [iconLeft]="true">
              </lib-button>
            </div>
          </div>
        }
        @if (popupDispalyObj.confirm) {
          <div class="d-flex align-items-end">
            <lib-button (callback)="footerButtonAction(popupDispalyObj.confirm)"
              [disabled]="popupDispalyObj.type == 'actionDialog' ? !desktopForm().valid : false"
            [buttonSize]="'medium'" [buttonText]="popupDispalyObj.confirm"></lib-button>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Mobile -->
@if (isMobile) {
  <div class="modal-body d-md-none">
    @if (popupDispalyObj.type == 'actionDialog') {
      <div
        class="d-flex flex-row psic-m-2"
        >
        <div class="flex-column">
          @if (popupDispalyObj.imageSrc) {
            <img
              src="{{ popupDispalyObj.imageSrc }}"
              [ngStyle]="{ width : '48px' }"
              alt="tick-img"
              />
          }
        </div>
        <div class="flex-column" class="psic-ml-2">
          <h6
            class="intro-quote-text"
            style="max-width: 325px"
            [innerHTML]="popupDispalyObj.message"
          ></h6>
          <p
            class="caption psic-pt-1"
            [innerHTML]="popupDispalyObj.messageExt"
          ></p>
        </div>
      </div>
    }
    @if (popupDispalyObj.type == 'paymentScehedule') {
      <div class="d-flex flex-row">
        <div class="psic-ml-4 flex-column">
          <h5 class="intro-quote-text psic-mb-4" [innerHTML]="popupDispalyObj.message"></h5>
          <p [ngClass]="popupDispalyObj.helpText ? 'alt' : 'alt-bold'" [innerHTML]="popupDispalyObj.messageExt"></p>
        </div>
      </div>
    }
    @if (popupDispalyObj.type == 'actionDialog') {
      <form [formGroup]="desktopForm()">
        @if (popupDispalyObj.fields?.length > 0) {
          <div class="d-flex flex-column align-items-center psic-mt-6">
            @for (field of popupDispalyObj.fields; track field) {
              @if (field.type == 'text' || field.type == 'email') {
                <div>
                  <lib-input-text [formControlName]="field.name" [field]="field"> </lib-input-text>
                </div>
              }
            }
          </div>
        }
      </form>
    }
  </div>
}
@if (isMobile) {
  <div class="modal-footer d-md-none d-flex flex-row align-items-center">
    @if (popupDispalyObj.cancel !== '') {
      <div class="d-flex flex-column flex-fill align-items-start">
        <div class="d-flex">
          <lib-button
            (callback)="footerButtonAction(popupDispalyObj.cancel)"
            [disabled]="false"
            [buttonTheme]="'tertiary'"
            [buttonType]="'borderless'"
            [buttonSize]="'large'"
            [buttonText]="popupDispalyObj.cancel"
            [libIcon]="'back'"
            [iconLeft]="true"
            class="psic-px-2"
            >
          </lib-button>
        </div>
      </div>
    }
    @if (popupDispalyObj.confirm) {
      <div
        class="d-flex flex-column justify-content-end align-items-center"
        >
        <lib-button
          (callback)="footerButtonAction(popupDispalyObj.confirm)"
          [disabled]="false"
          [buttonTheme]="'tertiary'"
          [buttonSize]="'large'"
          [buttonText]="popupDispalyObj.confirm"
          [disabled]="popupDispalyObj.type == 'actionDialog' ? !desktopForm().valid : false"
        ></lib-button>
      </div>
    }
  </div>
}